// import React, { Fragment, FunctionComponent } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTint } from "@fortawesome/free-solid-svg-icons";
// import { Graphics, Description } from "../styles/agency-income-metrics-styles";

// const Water: FunctionComponent<unknown> = () => (
//   <Fragment>
//     <Graphics>
//       <FontAwesomeIcon icon={faTint} />
//     </Graphics>
//     <Description>
//       This could buy you: <br /> <span>a clean water project sponsorship</span>!
//     </Description>
//   </Fragment>
// );

// export default Water;
